import { ENDPOINTS } from "./_config";

function navigateToLogin() {
  window.location.href = "/login";
}

const handleLogout = () => {
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  sessionStorage.removeItem("authToken");
  sessionStorage.removeItem("refreshToken");
  window.location.href = "/login";
};

export const getAndSetRefreshToken = async () => {
  const token = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
  const refreshToken = sessionStorage.getItem("refreshToken") || localStorage.getItem("refreshToken");
  // Check if refresh token is available
  if (!refreshToken) {
    console.error("No refresh token found. User needs to log in again.");
    handleLogout()
    return null;
  }
  if (!token) {
    console.error("No refresh token found. User needs to log in again.");
    handleLogout()
    return null;
  }
  try {
    // Send request to refresh the token
    const response = await fetch(ENDPOINTS.AUTH.REFRESH_TOKEN, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token, refreshToken }), // Include only required fields
    });
    // Check for response status
    if (response.status === 500) {
      handleLogout()
    }
    if (!response.ok) {
      navigateToLogin();
      return null;
    }

    // Parse the response JSON
    const data = await response.json();

    // Validate response structure
    if (!data.token || !data.refreshToken) {
      navigateToLogin();
      return null;
    }

    // Destructure new tokens
    const { token: newToken, refreshToken: newRefreshToken } = data;

    // Update tokens in sessionStorage
    sessionStorage.setItem("authToken", newToken);
    sessionStorage.setItem("refreshToken", newRefreshToken);

    return { token: newToken, refreshToken: newRefreshToken };

  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 500) {

    }
    navigateToLogin();
    return null;
  }
};

export const statusClasses = {
  "All": "bg-[#536493]",
  "In Progress": "bg-[#6F6EDE]",
  "Action Required": "bg-[#F26666]",
  "Requested Follow Up": "bg-[#FABC3F]",
  "Qualified": "bg-[#15B392]",
  "Booked": "bg-[#66D062]",
  "DNQ Criteria Not Met": "bg-[#CBA35C]",
  "DNQ Other": "bg-[#CBA35C]",
  "DNQ No Response": "bg-[#CBA35C]",
  "DNQ Not Interested": "bg-[#CBA35C]",
  "Non-textable": "bg-[#D73A60]",
  "To-call": "bg-[#605EA1]",
  "Contact Attempt 1": "bg-[#F28E58]",
  "Contact Attempt 2": "bg-[#F28E58]",
  "Contact Attempt 3": "bg-[#F28E58]",
  "Scheduled Screen": "bg-[#AA5486]"
};

export const funnelChartColors = {
  All: "#536493",
  "In Progress": "#6F6EDE",
  "Action Required": "#F26666",
  "Requested Follow Up": "#FABC3F",
  Qualified: "#15B392",
  Booked: "#66D062",
  "DNQ Criteria Not Met": "#CBA35C",
  "DNQ Other": "#CBA35C",
  "DNQ No Response": "#CBA35C",
  "DNQ Not Interested": "#CBA35C",
  "Non-textable": "#D73A60",
  "To-call": "#605EA1",
  "Contact Attempt 1": "#F28E58",
  "Contact Attempt 2": "#F28E58",
  "Contact Attempt 3": "#F28E58",
  "Scheduled Screen": "#AA5486",
};

export const bulkUploadStatusClass = {
  "isSuccessfull": "bg-[#66d0621a] !text-[#66d062] !border !border-[#66d062]",
  "isQueued": "bg-[#5364931a] !text-[#536493] !border !border-[#536493]",
  "isSkipped": "bg-[#b91c1c1a] !text-[#b91c1c] !border !border-[#b91c1c]",
}


export const docuSignStatusClass = {
  "recipient-completed": "!text-[#28A745] !border !border-[#28A745]",
  "envelope-Completed": "!text-[#28A745] !border !border-[#28A745]",
  "recipient-delivered": "!text-[#1E90FF] !border !border-[#1E90FF]",
  "envelope-delivered": "!text-[#1E90FF] !border !border-[#1E90FF]",
  "recipient-sent": "!text-[#D97706] !border !border-[#D97706]",
  "envelope-sent": "!text-[#D97706] !border !border-[#D97706]",
  "system-sent": "!text-[#D97706] !border !border-[#D97706]",
}

export const docuSingStatusMapping = {
  "recipient-completed": "Document Signed",
  "envelope-completed": "Document Signed",
  "recipient-delivered": "Document Delivered",
  "envelope-delivered": "Document Delivered",
  "recipient-sent": "Document Sent",
  "envelope-sent": "Document Sent",
  "system-sent": "Document Sent",
}

export const cn = (...classes) => classes.filter(Boolean).join(" ");